// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.slot-games-development-superior-section {
  padding: 4rem 0;
  margin: 0 auto;
}
.slot-games-development-superior-section .slot-games-development-superior-wrap {
  width: 100%;
  max-width: var(--containerWidth);
  margin: 0 auto;
}
.slot-games-development-superior-section .slot-games-development-superior-wrap .slot-games-development-superior-box .cards-grid {
  --cards-grid-number: 5;
  --cards-grid-gap: 2rem;
  display: grid;
  grid-template-columns: repeat(var(--cards-grid-number), 1fr);
  gap: var(--cards-grid-gap);
  padding: 1rem 0;
}
.slot-games-development-superior-section .slot-games-development-superior-wrap .slot-games-development-superior-box .card {
  width: 100%;
  height: 100%;
  background-color: var(--indigo-1000);
  border-radius: 1.25rem;
  box-shadow: 0px 4px 4px var(--black-150);
  display: flex;
  flex-direction: column;
  overflow: hidden;
  transform: skewY(-4deg);
}
.slot-games-development-superior-section .slot-games-development-superior-wrap .slot-games-development-superior-box .card .card-body {
  width: 100%;
  display: flex;
  justify-content: center;
  align-items: center;
  flex-direction: column;
  gap: 0.75rem;
  padding: 2rem 1.25rem;
  transform: skewY(4deg);
}
.slot-games-development-superior-section .slot-games-development-superior-wrap .slot-games-development-superior-box .card .card-body .number-text {
  color: var(--white-1000);
  font-size: 3.25rem;
  font-weight: 700;
  line-height: 1.4;
  text-align: center;
}
.slot-games-development-superior-section .slot-games-development-superior-wrap .slot-games-development-superior-box .card .card-body .title-text {
  color: var(--white-1000);
  font-size: 1.5rem;
  font-weight: 500;
  line-height: 1.4;
  text-align: center;
}
.slot-games-development-superior-section .slot-games-development-superior-wrap .slot-games-development-superior-box .btn-box {
  display: flex;
  justify-content: center;
  margin-top: 4rem;
}
@media screen and (max-width: 991.98px) {
  .slot-games-development-superior-section {
    padding: 2.5rem 0;
  }
  .slot-games-development-superior-section .slot-games-development-superior-wrap .slot-games-development-superior-box .cards-grid {
    --cards-grid-number: 3;
    --cards-grid-gap: 1.25rem;
  }
  .slot-games-development-superior-section .slot-games-development-superior-wrap .slot-games-development-superior-box .card {
    border-radius: 1rem;
  }
  .slot-games-development-superior-section .slot-games-development-superior-wrap .slot-games-development-superior-box .card .card-body {
    padding: 1.5rem 1rem;
  }
  .slot-games-development-superior-section .slot-games-development-superior-wrap .slot-games-development-superior-box .card .card-body .number-text {
    font-size: 2.25rem;
  }
  .slot-games-development-superior-section .slot-games-development-superior-wrap .slot-games-development-superior-box .card .card-body .title-text {
    font-size: 1rem;
  }
  .slot-games-development-superior-section .slot-games-development-superior-wrap .slot-games-development-superior-box .btn-box {
    margin-top: 2.5rem;
  }
}
@media screen and (max-width: 767.98px) {
  .slot-games-development-superior-section {
    padding: 2rem 0;
  }
  .slot-games-development-superior-section .slot-games-development-superior-wrap .slot-games-development-superior-box .cards-grid {
    --cards-grid-number: 2;
    --cards-grid-gap: 1rem;
  }
  .slot-games-development-superior-section .slot-games-development-superior-wrap .slot-games-development-superior-box .card .card-body {
    gap: 0.5rem;
  }
  .slot-games-development-superior-section .slot-games-development-superior-wrap .slot-games-development-superior-box .card .card-body .number-text {
    font-size: 1.875rem;
  }
  .slot-games-development-superior-section .slot-games-development-superior-wrap .slot-games-development-superior-box .card .card-body .title-text {
    font-size: 0.875rem;
  }
  .slot-games-development-superior-section .slot-games-development-superior-wrap .slot-games-development-superior-box .btn-box {
    margin-top: 1.25rem;
  }
}
@media screen and (max-width: 639.98px) {
  .slot-games-development-superior-section {
    padding: 2rem 0;
  }
  .slot-games-development-superior-section .slot-games-development-superior-wrap .slot-games-development-superior-box .cards-grid {
    --cards-grid-number: 2;
    --cards-grid-gap: 1rem;
  }
}`, "",{"version":3,"sources":["webpack://./src/components/SlotGamesDevelopmentSuperiorSection/SlotGamesDevelopmentSuperiorStyle.scss"],"names":[],"mappings":"AAAA;EACE,eAAA;EACA,cAAA;AACF;AACE;EACE,WAAA;EACA,gCAAA;EACA,cAAA;AACJ;AAEM;EACE,sBAAA;EACA,sBAAA;EACA,aAAA;EACA,4DAAA;EACA,0BAAA;EACA,eAAA;AAAR;AAGM;EACE,WAAA;EACA,YAAA;EACA,oCAAA;EACA,sBAAA;EACA,wCAAA;EACA,aAAA;EACA,sBAAA;EACA,gBAAA;EACA,uBAAA;AADR;AAGQ;EACE,WAAA;EACA,aAAA;EACA,uBAAA;EACA,mBAAA;EACA,sBAAA;EACA,YAAA;EACA,qBAAA;EACA,sBAAA;AADV;AAGU;EACE,wBAAA;EACA,kBAAA;EACA,gBAAA;EACA,gBAAA;EACA,kBAAA;AADZ;AAIU;EACE,wBAAA;EACA,iBAAA;EACA,gBAAA;EACA,gBAAA;EACA,kBAAA;AAFZ;AAOM;EACE,aAAA;EACA,uBAAA;EACA,gBAAA;AALR;AAUE;EAlEF;IAmEI,iBAAA;EAPF;EAWM;IACE,sBAAA;IACA,yBAAA;EATR;EAYM;IACE,mBAAA;EAVR;EAYQ;IACE,oBAAA;EAVV;EAYU;IACE,kBAAA;EAVZ;EAaU;IACE,eAAA;EAXZ;EAgBM;IACE,kBAAA;EAdR;AACF;AAmBE;EAnGF;IAoGI,eAAA;EAhBF;EAoBM;IACE,sBAAA;IACA,sBAAA;EAlBR;EAsBQ;IACE,WAAA;EApBV;EAsBU;IACE,mBAAA;EApBZ;EAuBU;IACE,mBAAA;EArBZ;EA0BM;IACE,mBAAA;EAxBR;AACF;AA6BE;EAlIF;IAmII,eAAA;EA1BF;EA8BM;IACE,sBAAA;IACA,sBAAA;EA5BR;AACF","sourcesContent":[".slot-games-development-superior-section {\n  padding: 4rem 0;\n  margin: 0 auto;\n\n  .slot-games-development-superior-wrap {\n    width: 100%;\n    max-width: var(--containerWidth);\n    margin: 0 auto;\n\n    .slot-games-development-superior-box {\n      .cards-grid {\n        --cards-grid-number: 5;\n        --cards-grid-gap: 2rem;\n        display: grid;\n        grid-template-columns: repeat(var(--cards-grid-number), 1fr);\n        gap: var(--cards-grid-gap);\n        padding: 1rem 0;\n      }\n\n      .card {\n        width: 100%;\n        height: 100%;\n        background-color: var(--indigo-1000);\n        border-radius: 1.25rem;\n        box-shadow: 0px 4px 4px var(--black-150);\n        display: flex;\n        flex-direction: column;\n        overflow: hidden;\n        transform: skewY(-4deg);\n      \n        .card-body {\n          width: 100%;\n          display: flex;\n          justify-content: center;\n          align-items: center;\n          flex-direction: column;\n          gap: 0.75rem;\n          padding: 2rem 1.25rem;\n          transform: skewY(4deg);\n\n          .number-text {\n            color: var(--white-1000);\n            font-size: 3.25rem;\n            font-weight: 700;\n            line-height: 1.4;\n            text-align: center;\n          }\n\n          .title-text {\n            color: var(--white-1000);\n            font-size: 1.5rem;\n            font-weight: 500;\n            line-height: 1.4;\n            text-align: center;\n          }\n        }\n      }\n\n      .btn-box {\n        display: flex;\n        justify-content: center;\n        margin-top: 4rem;\n      }\n    }\n  }\n\n  @media screen and (max-width: 991.98px) {\n    padding: 2.5rem 0;\n\n    .slot-games-development-superior-wrap {  \n      .slot-games-development-superior-box {\n        .cards-grid {\n          --cards-grid-number: 3;\n          --cards-grid-gap: 1.25rem;\n        }\n  \n        .card {\n          border-radius: 1rem;\n        \n          .card-body {\n            padding: 1.5rem 1rem;\n  \n            .number-text {\n              font-size: 2.25rem;\n            }\n\n            .title-text {\n              font-size: 1rem;\n            }\n          }\n        }\n  \n        .btn-box {\n          margin-top: 2.5rem;\n        }\n      }\n    }\n  }\n\n  @media screen and (max-width: 767.98px) {\n    padding: 2rem 0;\n\n    .slot-games-development-superior-wrap {  \n      .slot-games-development-superior-box {\n        .cards-grid {\n          --cards-grid-number: 2;\n          --cards-grid-gap: 1rem;\n        }\n  \n        .card {        \n          .card-body { \n            gap: 0.5rem;\n\n            .number-text {\n              font-size: 1.875rem;\n            }\n\n            .title-text {\n              font-size: 0.875rem;\n            }\n          }\n        }\n  \n        .btn-box {\n          margin-top: 1.25rem;\n        }\n      }\n    }\n  }\n\n  @media screen and (max-width: 639.98px) {\n    padding: 2rem 0;\n\n    .slot-games-development-superior-wrap {  \n      .slot-games-development-superior-box {\n        .cards-grid {\n          --cards-grid-number: 2;\n          --cards-grid-gap: 1rem;\n        }\n      }\n    }\n  }\n}\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
